/**
 * 交易阶段枚举
 */
export enum TradingPhase {
  /** 盘前阶段 (US EST 4:00-9:30 / HK 盘前竞价) */
  PRE_MARKET = "pre_market",
  /** 盘中阶段 (US EST 9:30-16:00 / HK 持续交易 09:30-12:00, 13:00-16:00) */
  IN_MARKET = "in_market",
  /** 盘后阶段 (US EST 16:00-20:00) */
  AFTER_MARKET = "after_market",
  /** 夜盘/休市 (US EST 20:00-4:00 / HK 交易结束后) */
  CLOSED_MARKET = "closed_market",
  /** 午休时段 (HK 12:00-13:00) */
  LUNCH = "lunch",
  /** 收市竞价时段 (HK 16:00-16:10) */
  CLOSING_AUCTION = "closing_auction",
}
